/* noui slider js */
!function(a){"function"==typeof define&&define.amd?define([],a):"object"==typeof exports?module.exports=a():window.noUiSlider=a()}(function(){"use strict";function a(a){return a.filter(function(a){return this[a]?!1:this[a]=!0},{})}function b(a,b){return Math.round(a/b)*b}function c(a){var b=a.getBoundingClientRect(),c=a.ownerDocument,d=c.documentElement,e=l();return/webkit.*Chrome.*Mobile/i.test(navigator.userAgent)&&(e.x=0),{top:b.top+e.y-d.clientTop,left:b.left+e.x-d.clientLeft}}function d(a){return"number"==typeof a&&!isNaN(a)&&isFinite(a)}function e(a,b,c){i(a,b),setTimeout(function(){j(a,b)},c)}function f(a){return Math.max(Math.min(a,100),0)}function g(a){return Array.isArray(a)?a:[a]}function h(a){var b=a.split(".");return b.length>1?b[1].length:0}function i(a,b){a.classList?a.classList.add(b):a.className+=" "+b}function j(a,b){a.classList?a.classList.remove(b):a.className=a.className.replace(new RegExp("(^|\\b)"+b.split(" ").join("|")+"(\\b|$)","gi")," ")}function k(a,b){return a.classList?a.classList.contains(b):new RegExp("\\b"+b+"\\b").test(a.className)}function l(){var a=void 0!==window.pageXOffset,b="CSS1Compat"===(document.compatMode||""),c=a?window.pageXOffset:b?document.documentElement.scrollLeft:document.body.scrollLeft,d=a?window.pageYOffset:b?document.documentElement.scrollTop:document.body.scrollTop;return{x:c,y:d}}function m(){return window.navigator.pointerEnabled?{start:"pointerdown",move:"pointermove",end:"pointerup"}:window.navigator.msPointerEnabled?{start:"MSPointerDown",move:"MSPointerMove",end:"MSPointerUp"}:{start:"mousedown touchstart",move:"mousemove touchmove",end:"mouseup touchend"}}function n(a,b){return 100/(b-a)}function o(a,b){return 100*b/(a[1]-a[0])}function p(a,b){return o(a,a[0]<0?b+Math.abs(a[0]):b-a[0])}function q(a,b){return b*(a[1]-a[0])/100+a[0]}function r(a,b){for(var c=1;a>=b[c];)c+=1;return c}function s(a,b,c){if(c>=a.slice(-1)[0])return 100;var d,e,f,g,h=r(c,a);return d=a[h-1],e=a[h],f=b[h-1],g=b[h],f+p([d,e],c)/n(f,g)}function t(a,b,c){if(c>=100)return a.slice(-1)[0];var d,e,f,g,h=r(c,b);return d=a[h-1],e=a[h],f=b[h-1],g=b[h],q([d,e],(c-f)*n(f,g))}function u(a,c,d,e){if(100===e)return e;var f,g,h=r(e,a);return d?(f=a[h-1],g=a[h],e-f>(g-f)/2?g:f):c[h-1]?a[h-1]+b(e-a[h-1],c[h-1]):e}function v(a,b,c){var e;if("number"==typeof b&&(b=[b]),"[object Array]"!==Object.prototype.toString.call(b))throw new Error("noUiSlider: 'range' contains invalid value.");if(e="min"===a?0:"max"===a?100:parseFloat(a),!d(e)||!d(b[0]))throw new Error("noUiSlider: 'range' value isn't numeric.");c.xPct.push(e),c.xVal.push(b[0]),e?c.xSteps.push(isNaN(b[1])?!1:b[1]):isNaN(b[1])||(c.xSteps[0]=b[1])}function w(a,b,c){return b?void(c.xSteps[a]=o([c.xVal[a],c.xVal[a+1]],b)/n(c.xPct[a],c.xPct[a+1])):!0}function x(a,b,c,d){this.xPct=[],this.xVal=[],this.xSteps=[d||!1],this.xNumSteps=[!1],this.snap=b,this.direction=c;var e,f=[];for(e in a)a.hasOwnProperty(e)&&f.push([a[e],e]);for(f.length&&"object"==typeof f[0][0]?f.sort(function(a,b){return a[0][0]-b[0][0]}):f.sort(function(a,b){return a[0]-b[0]}),e=0;e<f.length;e++)v(f[e][1],f[e][0],this);for(this.xNumSteps=this.xSteps.slice(0),e=0;e<this.xNumSteps.length;e++)w(e,this.xNumSteps[e],this)}function y(a,b){if(!d(b))throw new Error("noUiSlider: 'step' is not numeric.");a.singleStep=b}function z(a,b){if("object"!=typeof b||Array.isArray(b))throw new Error("noUiSlider: 'range' is not an object.");if(void 0===b.min||void 0===b.max)throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");if(b.min===b.max)throw new Error("noUiSlider: 'range' 'min' and 'max' cannot be equal.");a.spectrum=new x(b,a.snap,a.dir,a.singleStep)}function A(a,b){if(b=g(b),!Array.isArray(b)||!b.length||b.length>2)throw new Error("noUiSlider: 'start' option is incorrect.");a.handles=b.length,a.start=b}function B(a,b){if(a.snap=b,"boolean"!=typeof b)throw new Error("noUiSlider: 'snap' option must be a boolean.")}function C(a,b){if(a.animate=b,"boolean"!=typeof b)throw new Error("noUiSlider: 'animate' option must be a boolean.")}function D(a,b){if(a.animationDuration=b,"number"!=typeof b)throw new Error("noUiSlider: 'animationDuration' option must be a number.")}function E(a,b){if("lower"===b&&1===a.handles)a.connect=1;else if("upper"===b&&1===a.handles)a.connect=2;else if(b===!0&&2===a.handles)a.connect=3;else{if(b!==!1)throw new Error("noUiSlider: 'connect' option doesn't match handle count.");a.connect=0}}function F(a,b){switch(b){case"horizontal":a.ort=0;break;case"vertical":a.ort=1;break;default:throw new Error("noUiSlider: 'orientation' option is invalid.")}}function G(a,b){if(!d(b))throw new Error("noUiSlider: 'margin' option must be numeric.");if(0!==b&&(a.margin=a.spectrum.getMargin(b),!a.margin))throw new Error("noUiSlider: 'margin' option is only supported on linear sliders.")}function H(a,b){if(!d(b))throw new Error("noUiSlider: 'limit' option must be numeric.");if(a.limit=a.spectrum.getMargin(b),!a.limit)throw new Error("noUiSlider: 'limit' option is only supported on linear sliders.")}function I(a,b){switch(b){case"ltr":a.dir=0;break;case"rtl":a.dir=1,a.connect=[0,2,1,3][a.connect];break;default:throw new Error("noUiSlider: 'direction' option was not recognized.")}}function J(a,b){if("string"!=typeof b)throw new Error("noUiSlider: 'behaviour' must be a string containing options.");var c=b.indexOf("tap")>=0,d=b.indexOf("drag")>=0,e=b.indexOf("fixed")>=0,f=b.indexOf("snap")>=0,g=b.indexOf("hover")>=0;if(d&&!a.connect)throw new Error("noUiSlider: 'drag' behaviour must be used with 'connect': true.");a.events={tap:c||f,drag:d,fixed:e,snap:f,hover:g}}function K(a,b){var c;if(b!==!1)if(b===!0)for(a.tooltips=[],c=0;c<a.handles;c++)a.tooltips.push(!0);else{if(a.tooltips=g(b),a.tooltips.length!==a.handles)throw new Error("noUiSlider: must pass a formatter for all handles.");a.tooltips.forEach(function(a){if("boolean"!=typeof a&&("object"!=typeof a||"function"!=typeof a.to))throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.")})}}function L(a,b){if(a.format=b,"function"==typeof b.to&&"function"==typeof b.from)return!0;throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.")}function M(a,b){if(void 0!==b&&"string"!=typeof b&&b!==!1)throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");a.cssPrefix=b}function N(a,b){if(void 0!==b&&"object"!=typeof b)throw new Error("noUiSlider: 'cssClasses' must be an object.");if("string"==typeof a.cssPrefix){a.cssClasses={};for(var c in b)b.hasOwnProperty(c)&&(a.cssClasses[c]=a.cssPrefix+b[c])}else a.cssClasses=b}function O(a){var b,c={margin:0,limit:0,animate:!0,animationDuration:300,format:R};b={step:{r:!1,t:y},start:{r:!0,t:A},connect:{r:!0,t:E},direction:{r:!0,t:I},snap:{r:!1,t:B},animate:{r:!1,t:C},animationDuration:{r:!1,t:D},range:{r:!0,t:z},orientation:{r:!1,t:F},margin:{r:!1,t:G},limit:{r:!1,t:H},behaviour:{r:!0,t:J},format:{r:!1,t:L},tooltips:{r:!1,t:K},cssPrefix:{r:!1,t:M},cssClasses:{r:!1,t:N}};var d={connect:!1,direction:"ltr",behaviour:"tap",orientation:"horizontal",cssPrefix:"noUi-",cssClasses:{target:"target",base:"base",origin:"origin",handle:"handle",handleLower:"handle-lower",handleUpper:"handle-upper",horizontal:"horizontal",vertical:"vertical",background:"background",connect:"connect",ltr:"ltr",rtl:"rtl",draggable:"draggable",drag:"state-drag",tap:"state-tap",active:"active",stacking:"stacking",tooltip:"tooltip",pips:"pips",pipsHorizontal:"pips-horizontal",pipsVertical:"pips-vertical",marker:"marker",markerHorizontal:"marker-horizontal",markerVertical:"marker-vertical",markerNormal:"marker-normal",markerLarge:"marker-large",markerSub:"marker-sub",value:"value",valueHorizontal:"value-horizontal",valueVertical:"value-vertical",valueNormal:"value-normal",valueLarge:"value-large",valueSub:"value-sub"}};return Object.keys(b).forEach(function(e){if(void 0===a[e]&&void 0===d[e]){if(b[e].r)throw new Error("noUiSlider: '"+e+"' is required.");return!0}b[e].t(c,void 0===a[e]?d[e]:a[e])}),c.pips=a.pips,c.style=c.ort?"top":"left",c}function P(b,d,n){function o(a,b,c){var d=a+b[0],e=a+b[1];return c?(0>d&&(e+=Math.abs(d)),e>100&&(d-=e-100),[f(d),f(e)]):[d,e]}function p(a,b){a.preventDefault();var c,d,e=0===a.type.indexOf("touch"),f=0===a.type.indexOf("mouse"),g=0===a.type.indexOf("pointer"),h=a;return 0===a.type.indexOf("MSPointer")&&(g=!0),e&&(c=a.changedTouches[0].pageX,d=a.changedTouches[0].pageY),b=b||l(),(f||g)&&(c=a.clientX+b.x,d=a.clientY+b.y),h.pageOffset=b,h.points=[c,d],h.cursor=f||g,h}function q(a,b){var c=document.createElement("div"),e=document.createElement("div"),f=[d.cssClasses.handleLower,d.cssClasses.handleUpper];return a&&f.reverse(),i(e,d.cssClasses.handle),i(e,f[b]),i(c,d.cssClasses.origin),c.appendChild(e),c}function r(a,b,c){switch(a){case 1:i(b,d.cssClasses.connect),i(c[0],d.cssClasses.background);break;case 3:i(c[1],d.cssClasses.background);case 2:i(c[0],d.cssClasses.connect);case 0:i(b,d.cssClasses.background)}}function s(a,b,c){var d,e=[];for(d=0;a>d;d+=1)e.push(c.appendChild(q(b,d)));return e}function t(a,b,c){i(c,d.cssClasses.target),0===a?i(c,d.cssClasses.ltr):i(c,d.cssClasses.rtl),0===b?i(c,d.cssClasses.horizontal):i(c,d.cssClasses.vertical);var e=document.createElement("div");return i(e,d.cssClasses.base),c.appendChild(e),e}function u(a,b){if(!d.tooltips[b])return!1;var c=document.createElement("div");return c.className=d.cssClasses.tooltip,a.firstChild.appendChild(c)}function v(){d.dir&&d.tooltips.reverse();var a=W.map(u);d.dir&&(a.reverse(),d.tooltips.reverse()),S("update",function(b,c,e){a[c]&&(a[c].innerHTML=d.tooltips[c]===!0?b[c]:d.tooltips[c].to(e[c]))})}function w(a,b,c){if("range"===a||"steps"===a)return _.xVal;if("count"===a){var d,e=100/(b-1),f=0;for(b=[];(d=f++*e)<=100;)b.push(d);a="positions"}return"positions"===a?b.map(function(a){return _.fromStepping(c?_.getStep(a):a)}):"values"===a?c?b.map(function(a){return _.fromStepping(_.getStep(_.toStepping(a)))}):b:void 0}function x(b,c,d){function e(a,b){return(a+b).toFixed(7)/1}var f=_.direction,g={},h=_.xVal[0],i=_.xVal[_.xVal.length-1],j=!1,k=!1,l=0;return _.direction=0,d=a(d.slice().sort(function(a,b){return a-b})),d[0]!==h&&(d.unshift(h),j=!0),d[d.length-1]!==i&&(d.push(i),k=!0),d.forEach(function(a,f){var h,i,m,n,o,p,q,r,s,t,u=a,v=d[f+1];if("steps"===c&&(h=_.xNumSteps[f]),h||(h=v-u),u!==!1&&void 0!==v)for(i=u;v>=i;i=e(i,h)){for(n=_.toStepping(i),o=n-l,r=o/b,s=Math.round(r),t=o/s,m=1;s>=m;m+=1)p=l+m*t,g[p.toFixed(5)]=["x",0];q=d.indexOf(i)>-1?1:"steps"===c?2:0,!f&&j&&(q=0),i===v&&k||(g[n.toFixed(5)]=[i,q]),l=n}}),_.direction=f,g}function y(a,b,c){function e(a,b){var c=b===d.cssClasses.value,e=c?m:n,f=c?k:l;return b+" "+e[d.ort]+" "+f[a]}function f(a,b,c){return'class="'+e(c[1],b)+'" style="'+d.style+": "+a+'%"'}function g(a,e){_.direction&&(a=100-a),e[1]=e[1]&&b?b(e[0],e[1]):e[1],j+="<div "+f(a,d.cssClasses.marker,e)+"></div>",e[1]&&(j+="<div "+f(a,d.cssClasses.value,e)+">"+c.to(e[0])+"</div>")}var h=document.createElement("div"),j="",k=[d.cssClasses.valueNormal,d.cssClasses.valueLarge,d.cssClasses.valueSub],l=[d.cssClasses.markerNormal,d.cssClasses.markerLarge,d.cssClasses.markerSub],m=[d.cssClasses.valueHorizontal,d.cssClasses.valueVertical],n=[d.cssClasses.markerHorizontal,d.cssClasses.markerVertical];return i(h,d.cssClasses.pips),i(h,0===d.ort?d.cssClasses.pipsHorizontal:d.cssClasses.pipsVertical),Object.keys(a).forEach(function(b){g(b,a[b])}),h.innerHTML=j,h}function z(a){var b=a.mode,c=a.density||1,d=a.filter||!1,e=a.values||!1,f=a.stepped||!1,g=w(b,e,f),h=x(c,b,g),i=a.format||{to:Math.round};return Z.appendChild(y(h,d,i))}function A(){var a=V.getBoundingClientRect(),b="offset"+["Width","Height"][d.ort];return 0===d.ort?a.width||V[b]:a.height||V[b]}function B(a,b,c){var e;for(e=0;e<d.handles;e++)if(-1===$[e])return;void 0!==b&&1!==d.handles&&(b=Math.abs(b-d.dir)),Object.keys(ba).forEach(function(d){var e=d.split(".")[0];a===e&&ba[d].forEach(function(a){a.call(X,g(P()),b,g(C(Array.prototype.slice.call(aa))),c||!1,$)})})}function C(a){return 1===a.length?a[0]:d.dir?a.reverse():a}function D(a,b,c,e){var f=function(b){return Z.hasAttribute("disabled")?!1:k(Z,d.cssClasses.tap)?!1:(b=p(b,e.pageOffset),a===Y.start&&void 0!==b.buttons&&b.buttons>1?!1:e.hover&&b.buttons?!1:(b.calcPoint=b.points[d.ort],void c(b,e)))},g=[];return a.split(" ").forEach(function(a){b.addEventListener(a,f,!1),g.push([a,f])}),g}function E(a,b){if(-1===navigator.appVersion.indexOf("MSIE 9")&&0===a.buttons&&0!==b.buttonsProperty)return F(a,b);var c,d,e=b.handles||W,f=!1,g=100*(a.calcPoint-b.start)/b.baseSize,h=e[0]===W[0]?0:1;if(c=o(g,b.positions,e.length>1),f=L(e[0],c[h],1===e.length),e.length>1){if(f=L(e[1],c[h?0:1],!1)||f)for(d=0;d<b.handles.length;d++)B("slide",d)}else f&&B("slide",h)}function F(a,b){var c=V.querySelector("."+d.cssClasses.active),e=b.handles[0]===W[0]?0:1;null!==c&&j(c,d.cssClasses.active),a.cursor&&(document.body.style.cursor="",document.body.removeEventListener("selectstart",document.body.noUiListener));var f=document.documentElement;f.noUiListeners.forEach(function(a){f.removeEventListener(a[0],a[1])}),j(Z,d.cssClasses.drag),B("set",e),B("change",e),void 0!==b.handleNumber&&B("end",b.handleNumber)}function G(a,b){"mouseout"===a.type&&"HTML"===a.target.nodeName&&null===a.relatedTarget&&F(a,b)}function H(a,b){var c=document.documentElement;if(1===b.handles.length){if(b.handles[0].hasAttribute("disabled"))return!1;i(b.handles[0].children[0],d.cssClasses.active)}a.preventDefault(),a.stopPropagation();var e=D(Y.move,c,E,{start:a.calcPoint,baseSize:A(),pageOffset:a.pageOffset,handles:b.handles,handleNumber:b.handleNumber,buttonsProperty:a.buttons,positions:[$[0],$[W.length-1]]}),f=D(Y.end,c,F,{handles:b.handles,handleNumber:b.handleNumber}),g=D("mouseout",c,G,{handles:b.handles,handleNumber:b.handleNumber});if(c.noUiListeners=e.concat(f,g),a.cursor){document.body.style.cursor=getComputedStyle(a.target).cursor,W.length>1&&i(Z,d.cssClasses.drag);var h=function(){return!1};document.body.noUiListener=h,document.body.addEventListener("selectstart",h,!1)}void 0!==b.handleNumber&&B("start",b.handleNumber)}function I(a){var b,f,g=a.calcPoint,h=0;return a.stopPropagation(),W.forEach(function(a){h+=c(a)[d.style]}),b=h/2>g||1===W.length?0:1,W[b].hasAttribute("disabled")&&(b=b?0:1),g-=c(V)[d.style],f=100*g/A(),d.events.snap||e(Z,d.cssClasses.tap,d.animationDuration),W[b].hasAttribute("disabled")?!1:(L(W[b],f),B("slide",b,!0),B("set",b,!0),B("change",b,!0),void(d.events.snap&&H(a,{handles:[W[b]]})))}function J(a){var b=a.calcPoint-c(V)[d.style],e=_.getStep(100*b/A()),f=_.fromStepping(e);Object.keys(ba).forEach(function(a){"hover"===a.split(".")[0]&&ba[a].forEach(function(a){a.call(X,f)})})}function K(a){if(a.fixed||W.forEach(function(a,b){D(Y.start,a.children[0],H,{handles:[a],handleNumber:b})}),a.tap&&D(Y.start,V,I,{handles:W}),a.hover&&D(Y.move,V,J,{hover:!0}),a.drag){var b=[V.querySelector("."+d.cssClasses.connect)];i(b[0],d.cssClasses.draggable),a.fixed&&b.push(W[b[0]===W[0]?1:0].children[0]),b.forEach(function(a){D(Y.start,a,H,{handles:W})})}}function L(a,b,c){var e=a!==W[0]?1:0,g=$[0]+d.margin,h=$[1]-d.margin,k=$[0]+d.limit,l=$[1]-d.limit;return W.length>1&&(b=e?Math.max(b,g):Math.min(b,h)),c!==!1&&d.limit&&W.length>1&&(b=e?Math.min(b,k):Math.max(b,l)),b=_.getStep(b),b=f(b),b===$[e]?!1:(window.requestAnimationFrame?window.requestAnimationFrame(function(){a.style[d.style]=b+"%"}):a.style[d.style]=b+"%",a.previousSibling||(j(a,d.cssClasses.stacking),b>50&&i(a,d.cssClasses.stacking)),$[e]=b,aa[e]=_.fromStepping(b),B("update",e),!0)}function M(a,b){var c,e,f;for(d.limit&&(a+=1),c=0;a>c;c+=1)e=c%2,f=b[e],null!==f&&f!==!1&&("number"==typeof f&&(f=String(f)),f=d.format.from(f),(f===!1||isNaN(f)||L(W[e],_.toStepping(f),c===3-d.dir)===!1)&&B("update",e))}function N(a,b){var c,f,h=g(a);for(b=void 0===b?!0:!!b,d.dir&&d.handles>1&&h.reverse(),d.animate&&-1!==$[0]&&e(Z,d.cssClasses.tap,d.animationDuration),c=W.length>1?3:1,1===h.length&&(c=1),M(c,h),f=0;f<W.length;f++)null!==h[f]&&b&&B("set",f)}function P(){var a,b=[];for(a=0;a<d.handles;a+=1)b[a]=d.format.to(aa[a]);return C(b)}function Q(){for(var a in d.cssClasses)d.cssClasses.hasOwnProperty(a)&&j(Z,d.cssClasses[a]);for(;Z.firstChild;)Z.removeChild(Z.firstChild);delete Z.noUiSlider}function R(){var a=$.map(function(a,b){var c=_.getApplicableStep(a),d=h(String(c[2])),e=aa[b],f=100===a?null:c[2],g=Number((e-c[2]).toFixed(d)),i=0===a?null:g>=c[1]?c[2]:c[0]||!1;return[i,f]});return C(a)}function S(a,b){ba[a]=ba[a]||[],ba[a].push(b),"update"===a.split(".")[0]&&W.forEach(function(a,b){B("update",b)})}function T(a){var b=a&&a.split(".")[0],c=b&&a.substring(b.length);Object.keys(ba).forEach(function(a){var d=a.split(".")[0],e=a.substring(d.length);b&&b!==d||c&&c!==e||delete ba[a]})}function U(a,b){var c=P(),e=O({start:[0,0],margin:a.margin,limit:a.limit,step:void 0===a.step?d.singleStep:a.step,range:a.range,animate:a.animate,snap:void 0===a.snap?d.snap:a.snap});["margin","limit","range","animate"].forEach(function(b){void 0!==a[b]&&(d[b]=a[b])}),e.spectrum.direction=_.direction,_=e.spectrum,$=[-1,-1],N(a.start||c,b)}var V,W,X,Y=m(),Z=b,$=[-1,-1],_=d.spectrum,aa=[],ba={};if(Z.noUiSlider)throw new Error("Slider was already initialized.");return V=t(d.dir,d.ort,Z),W=s(d.handles,d.dir,V),r(d.connect,Z,W),d.pips&&z(d.pips),d.tooltips&&v(),X={destroy:Q,steps:R,on:S,off:T,get:P,set:N,updateOptions:U,options:n,target:Z,pips:z},K(d.events),X}function Q(a,b){if(!a.nodeName)throw new Error("noUiSlider.create requires a single element.");var c=O(b,a),d=P(a,c,b);return d.set(c.start),a.noUiSlider=d,d}x.prototype.getMargin=function(a){return 2===this.xPct.length?o(this.xVal,a):!1},x.prototype.toStepping=function(a){return a=s(this.xVal,this.xPct,a),this.direction&&(a=100-a),a},x.prototype.fromStepping=function(a){return this.direction&&(a=100-a),t(this.xVal,this.xPct,a)},x.prototype.getStep=function(a){return this.direction&&(a=100-a),a=u(this.xPct,this.xSteps,this.snap,a),this.direction&&(a=100-a),a},x.prototype.getApplicableStep=function(a){var b=r(a,this.xPct),c=100===a?2:1;return[this.xNumSteps[b-2],this.xVal[b-c],this.xNumSteps[b-c]]},x.prototype.convert=function(a){return this.getStep(this.toStepping(a))};var R={to:function(a){return void 0!==a&&a.toFixed(2)},from:Number};return{create:Q}});

function spLoadScript(url, callback){

var script;

script = document.createElement('script');
script.type = 'text/javascript';
if(script.readyState){
script.onreadystatechange = function(){
if ( script.readyState === 'loaded' || script.readyState === 'complete'){
script.onreadystatechange = null;
callback();
}
};
}else{

script.onload = function(){
callback();
};
}
script.src = url;
document.getElementsByTagName('head')[0].appendChild(script);
}

function spLoadIWGApp(callback){

if(typeof $ == 'undefined' || typeof jQuery == 'undefined'){

spLoadScript('https://ajax.googleapis.com/ajax/libs/jquery/3.1.1/jquery.min.js', function(){
spLoadIWGApp(callback);
});
}else if(typeof $.cookie == 'undefined'){

spLoadScript('https://cdnjs.cloudflare.com/ajax/libs/jquery-cookie/1.4.1/jquery.cookie.js', function(){
spLoadIWGApp(callback);
});
}
else if(typeof  jQuery.ui == 'undefined' ){

spLoadScript('https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js', function(){
spLoadIWGApp(callback);
});
}else{
callback();
}
}


spLoadIWGApp(function(){



  /* global variable declaration */ 
  var SP_bugprice,SP_bugtotal,SP_numofpro,proTagsStr,SP_datevalue,SP_maxprice,SP_maxqty,SP_maxperprice,SP_maxdays,SP_getdays; 
  var SP_minprice,SP_minqty,SP_minperprice;
 
 

  /* Next step */
  $('.step-pager').on('click', function(){ 
    jumpTostep(this);       
  });
  var curURL = window.location.href;
  if (curURL.indexOf("/pages") > -1) {
    deliverydates();
  }
  getCookies();
  
  
  $('[name="cust_options"]').on('click', function(){  

    /*if(!$(this).parent('.input-i-bx').hasClass('active')){
      $(this).parents('.step-pg-bx').find('.input-i-bx').removeClass('active').next('.tab-open').slideUp();
      if($(this).is(':checked')){

        $(this).parents('.sp_options').find('.input-i-bx').addClass('active').next('.tab-open').slideDown();
      }
    }*/
	
   var ischeck = false; 
  /* $.each($(this).parents('.sp_options').find('[name="chckbox"]'), function(){ 
     console.log($(this).prop('checked'));
      if ($(this).prop('checked')==true){ 
       ischeck = true;
      }
    }); */
   // console.log(ischeck,'ischeck');
   // if(!ischeck){
      $(this).parents('.sp_options').find('[name="chckbox"]').prop('checked', true);	
 //   }
	
  //  $('[name="chckbox"]').attr('checked', false);
  //    $(this).parents('.sp_options').find('[name="chckbox"]').prop('checked', true);
  });

  $('.sp_options').find('[name="chckbox"]').on('change', function(){   
    var rval =  $(this).parents('.sp_options').find("[name='cust_options']").val(); 
    $('[name="cust_options"][value="'+rval+'"]').prop('checked','true');


    $('.sp_options input[name="chckbox"]').not($(this).parents('.sp_options').find('input[name="chckbox"]')).prop("checked", false);
  });
  
  $('.sp_options').find('.tab-click').on('click', function(){

    if($(this).hasClass('open')){
      //  $(this).parents('.input-i-bx').find('[name="cust_options"]').prop('checked','false').trigger('click');
    }else{

      $(this).addClass('open');
      //  $(this).parents('.input-i-bx').find('[name="cust_options"]').prop('checked','true').trigger('click');
    }
    // if(!$(this).parents('.input-i-bx').hasClass('active')){
    //  $(this).parents('.input-i-bx').find('[name="cust_options"]').prop('checked','true').trigger('click');
    // $(this).parents('.input-i-bx').toggleClass('active').parent('.sp_options').siblings('.sp_options').find('.input-i-bx').removeClass('active').find('.tab-open').slideDown();
    //   }
    //  $(this).parents('.sp_options').find('.tab-open').slideToggle().parent('.sp_options').siblings('.sp_options').find('.tab-open').slideUp();
  });
  
  /* Past Date selection disabled  */
 
  
  /* Validate price input allow only interger */
 
onload =function(){ 
  var ele = document.querySelectorAll('.sp-pricebox')[0]; 
  if(ele != undefined){
  ele.onkeypress = function(e) {
     if(isNaN(this.value+""+String.fromCharCode(e.charCode)))
        return false;
  }
  ele.onpaste = function(e){
     e.preventDefault();
  }
   var ele = document.querySelectorAll('.sp-pricebox')[1];
  ele.onkeypress = function(e) {
     if(isNaN(this.value+""+String.fromCharCode(e.charCode)))
        return false;
  }
  ele.onpaste = function(e){
     e.preventDefault();
  }
  }
}

  
  
  $(".sp-pricebox").on("keypress keyup blur", function (event) {
  //  $(this).val($(this).val().replace(/[^\d].+/, ""));
    var price_pro = $(this).parents('#step-1'); 
    var buget_price_val = $("input[name='pck-selector']:checked").parents('.input-i-bx').find('.sp-pricebox').val();
  
     var $this = $(this);
    if ((event.which != 46 || $this.val().indexOf('.') != -1) &&
       ((event.which < 48 || event.which > 57) &&
       (event.which != 0 && event.which != 8))) {
           event.preventDefault();
    }

    var text = $(this).val();
    if ((event.which == 46) && (text.indexOf('.') == -1)) {
        setTimeout(function() {
            if ($this.val().substring($this.val().indexOf('.')).length > 3) {
                $this.val($this.val().substring(0, $this.val().indexOf('.') + 3));
            }
        }, 1);
    }

    if ((text.indexOf('.') != -1) &&
        (text.substring(text.indexOf('.')).length > 2) &&
        (event.which != 0 && event.which != 8) &&
        ($(this)[0].selectionStart >= text.length - 2)) {
            event.preventDefault();
    }
    
   var isfloat = $(this).val().indexOf('.');
   if(isfloat > 0){
       var decimal = $(this).val().split('.'); 
      if(decimal[1].length > 2){ 
      	 var dec = Dec2(parseFloat($(this).val()));
         $(this).val(dec);
        
      }
        
     }
   
  if(isNaN(buget_price_val)){ 
      price_pro.find('.stp-error').text("Please enter valid value");      
    }else{ 
      price_pro.find('.stp-error').text(" ");  
      $(this).parent('.price-i-bx').removeClass("input-has-error");
    }
  });
  
   $('.sp-pricebox').bind("paste", function(e) {
    var text = e.originalEvent.clipboardData.getData('Text');
    if ($.isNumeric(text)) {
      if ((text.substring(text.indexOf('.')).length > 3) && (text.indexOf('.') > -1)) {
        e.preventDefault();
        $(this).val(text.substring(0, text.indexOf('.') + 3));
      }
    }
    else {
      e.preventDefault();
    }
  });
  
  
  
  /* Price radio remove error with selection */ 
  $('input[name="pck-selector"]').change(function(){
    $('input[name="pck-selector"]').removeClass("input-has-error");
    $('.stp-error').text("");
  });



function Dec2(num) {
  num = String(num);
  if(num.indexOf('.') !== -1) {
    var numarr = num.split(".");
    if (numarr.length == 1) {
      return Number(num);
    }
    else {
      return Number(numarr[0]+"."+numarr[1].charAt(0)+numarr[1].charAt(1));
    }
  }
  else {
    return Number(num);
  }  
}
  
function deliverydates(){
 
   setTimeout(function(){
    $( "#datepicker" ).datepicker({ minDate:0 });
   },1000);
}

function getCookies(){  

  SP_maxprice = $('[name="SP_maxPrice"]').val();
  SP_maxqty = $('[name="SP_maxQty"]').val();
  SP_maxperprice = $('[name="SP_maxperPrice"]').val();

  SP_minprice = parseFloat($('[name="SP_minPrice"]').val());
  SP_minqty = parseInt($('[name="SP_minQty"]').val());
  SP_minperprice = parseFloat($('[name="SP_minperPrice"]').val());

  SP_maxdays = 100;
  /* get saved cookies */ 
  SP_bugprice = $.cookie("SP_bugprice"); 
  SP_bugtotal = $.cookie("SP_totbudget"); 
  SP_numofpro = $.cookie("SP_numofpro");
  proTagsStr = $.cookie("SP_protag");
  SP_custprice = $.cookie("SP_custprice");
  SP_datevalue = $.cookie("SP_datevalue"); 
  SP_getdays = $.cookie("SP_days");
  SP_selcolor = $.cookie("SP_selcolor");
  if(SP_selcolor == null || SP_selcolor == undefined){
    SP_selcolor = $('[name="SP_selcolor"]').val();
  }
  if(SP_getdays == null || SP_getdays == undefined){
    SP_getdays = SP_maxdays;
  }
  /* step 1 value assign */
  if(SP_bugprice != null && SP_bugprice != undefined){
    $('#step-1').find('[data-value="'+SP_bugprice+'"]').attr('checked', 'checked');    
  } else {
    $('#step-1').find('[data-value="total_budget"]').attr('checked', 'checked');
    SP_bugprice ='total_budget';
  }
  var match_radio =  $('#step-1').find('[data-value="'+SP_bugprice+'"]').parents('.input-i-bx').find('.sp-pricebox');
  if(SP_bugtotal != null && SP_bugtotal != undefined){
    match_radio.val(parseFloat(SP_bugtotal));
  }

  $("input[name='cust_options'][value='" + SP_selcolor + "']").prop('checked', true).trigger('click');

  /* step 3 value assign */
  if(SP_datevalue != null && SP_datevalue != undefined){
  //  $("#datepicker").datepicker("setDate",SP_datevalue);
  } 
  /* step 2 value assign and check tags in collection page*/
  var proTagArr = [];  
  if(proTagsStr != null && proTagsStr!= undefined) {
    proTagArr = proTagsStr.split(',');
    $.each(proTagArr, function(i, val){       
      $('[clr="'+SP_selcolor+'"]').find("input[name='chckbox'][value='" + val + "']").prop('checked', true);
      $('.filter-block').find("input[name='chckbox'][value='" + val + "']").prop('checked', true);
    }); 
  }else{ 
    $('[clr="'+SP_selcolor+'"]').find("input[name='chckbox']").prop('checked', true);	
    $('.filter-block').find("input[name='chckbox']").prop('checked', true);
  }  

  if(SP_numofpro != null && SP_numofpro != undefined){
    $('#step-1').find(".sp-totpro").val(parseInt(SP_numofpro));
  }else{
    $('#step-1').find('.sp-totpro').val($('.qty-box').find('.sp-totpro').val());  
  }
  
  $('.filter-toggle').on('click', function(){
    $('.filter-sidebar').slideToggle();
  });
  
  var curURL = window.location.href;
   if (curURL.indexOf("/cart") > -1) {
    removeCartProduct();
    //return false;
  } 
  
  var isCart = false;
  if (curURL.indexOf("/collection") > -1) {
    rangeSlider();
      var color = $.cookie("SP_selcolor"); 
    var cookie_val = $.cookie("SP_protag");
    var array = [];
    if(cookie_val == '' || cookie_val == undefined){
      $('input[name="chckbox"]').prop("checked", false);
      // if(color== "1 Colour" ||color== "2 Colours" ||color== "Full Colour" ||color== "No Customization" ){ 
          if(color == "No Customization"){
          	  $("input[value='No Customization']").prop("checked", true);
          }
         else {
           $('input[name="chckbox"]').each(function(k,v){ 
             var cus_val = $(this).val() ;
            cus_val= cus_val.replace(/ /g, '');
            cus_val = '@'+cus_val.toLowerCase();
              scarr = color.split(' ');
             selclr = '@'+scarr[0].toLowerCase();
             
             if(cus_val.indexOf(selclr) != -1){ 
             	$(this).prop("checked", true);
             }
           })
         }
      // }
/*    if(color== "1 Colour" ||color== "2 Colour" ||color== "Full Colour" ||color== "No Customization" ){
      if(color == "1 Colour"){
        $('input[name="chckbox"]').prop("checked", true);
      }
      if(color == "2 Colour"){
        $("input[value='UV full colour print'],input[value='Embroidery'],input[value='Heat Transfer'],input[value='Full Custom']").prop("checked", true);
      }
      if(color == "4 Colour"){
        $("input[value='UV full colour print'],input[value='Embroidery'],input[value='Heat Transfer'],input[value='Full Custom']").prop("checked", true);
      }
    } else {*/
  /*    array = cookie_val.split(","); 
      
      $.each(array, function(k,v){ 
        $('input[value="'+v+'"]').prop("checked", true); 
      }); */
   // }
    }else{
      array = cookie_val.split(","); 
      
      $.each(array, function(k,v){
       $('input[value="'+v+'"]').prop("checked", true); 
      });  
    }
    
    var cust_price = 0;
    var arr = [];
    var curr_arr = [];
    $.each($("input[name='chckbox']:checked"), function(){  
      arr.push($(this).val()); 
      curr_arr.push(parseFloat($(this).attr('price')));
    //  cust_price = cust_price + parseFloat($(this).attr('price')); 
    });
     if(curr_arr.length > 0){
    cust_price = Math.min.apply(Math,curr_arr);
    }
  
    SP_custprice = parseFloat(cust_price);
    $.cookie("SP_protag", arr.toString(), {expires: 365, path: '/'}); 
    $.cookie("SP_custprice", cust_price, {expires: 365, path: '/'}); 
    proTagsStr = arr.toString();
    
    setTimeout(function(){ 
    filterProduct(parseFloat(SP_bugtotal),parseInt(SP_numofpro),SP_bugprice,proTagsStr,parseInt(SP_getdays),1,parseFloat(SP_custprice));    
    },2000);
  }

}

function rangeSlider(){ 
   var isinputchange = false;
  var isqtychange = false;
  var isdaychange = false;
  
  if(SP_maxqty == null || SP_maxqty == undefined){
    SP_maxqty = 100;
  }

  if(SP_bugprice != undefined && SP_bugprice != null && SP_bugprice == 'per_product_budget')
  {
    var SP_maxPr = SP_maxperprice;
     var minset =  parseInt(SP_minperprice); 
  } else {
    var SP_maxPr = SP_maxprice	
     var minset =  parseInt(SP_minprice); 
   }

  if((SP_maxprice == null || SP_maxprice == undefined ) && (SP_maxperprice == null || SP_maxperprice == undefined) ){
    var SP_maxPr = 700;
  }
  
 
  console.log(minset,'minset');
  priceSlider = document.getElementById('priceSlider');
  noUiSlider.create(priceSlider, {   
    animationDuration: 300,
    start: [0],
    step:0.01,
    range: {
      'min': minset,
      'max': parseInt(SP_maxPr)

    },
    format: {
      to: function ( value ) {          
        return value;
      },
      from: function ( value ) {      
        return value;
      }      
    }
  });
/*
  var priceValue = document.getElementById('price-value');
  priceSlider.noUiSlider.on('update', function (values, handle) {
    priceValue.innerHTML = parseInt(values[handle]);  
  });

  qtySlider = document.getElementById('qtySlider');
  noUiSlider.create(qtySlider, {
    animationDuration: 300,
    start: [0],
    step: 1,
    range: {
      'min': 10,
      'max': parseInt(SP_maxqty)

    },
    format: {
      to: function ( value ) {
        return value;
      },
      from: function ( value ) {
        return value;
      }
    }
  });
*/
 
    var jq = $;
  var priceValue = document.getElementById('price-value');
  
  /*priceSlider.noUiSlider.on('update', function (values, handle) { 
 //   priceValue.innerHTML = parseInt(values[handle]);  
    var slider_price = Number.isInteger(values[handle]) ? parseInt(values[handle]) : parseFloat(values[handle]).toFixed(2)  ; 
    var val =  slider_price;
    if( isinputchange ){
    //  priceValue.value = slider_price;
     
    }   
  });
*/
(function($) {
  $.fn.donetyping = function(callback) {
    var _this = $(this);
    var x_timer;
    _this.change(function() {
      clearTimeout(x_timer);
      x_timer = setTimeout(clear_timer, 1000);
    });

    function clear_timer() {
      clearTimeout(x_timer);
      callback.call(_this);
    }
  }
})(jQuery);

(function($) {
  $.fn.donetyping2 = function(callback) {
    var _this = $(this);
    var x_timer;
    _this.keyup(function() {
      clearTimeout(x_timer);
      x_timer = setTimeout(clear_timer, 1000);
    });

    function clear_timer() {
      clearTimeout(x_timer);
      callback.call(_this);
    }
  }
})(jQuery);
  
onload =function(){ 
  var ele =  document.getElementById('price-value');
  ele.onkeypress = function(e) {
     if(isNaN(this.value+""+String.fromCharCode(e.charCode)))
        return false;
  }
  ele.onpaste = function(e){
     e.preventDefault();
  }
  
}
 

  $("#price-value").on("change keyup keypress", function (event) {
    var $this = $(this);
    if ((event.which != 46 || $this.val().indexOf('.') != -1) &&
        ((event.which < 48 || event.which > 57) &&
         (event.which != 0 && event.which != 8))) {
      event.preventDefault();
    }

    var text = $(this).val();
    if ((event.which == 46) && (text.indexOf('.') == -1)) {
      setTimeout(function() {
        if ($this.val().substring($this.val().indexOf('.')).length > 3) {
          $this.val($this.val().substring(0, $this.val().indexOf('.') + 3));
        }
      }, 1);
    }

    if ((text.indexOf('.') != -1) &&
        (text.substring(text.indexOf('.')).length > 2) &&
        (event.which != 0 && event.which != 8) &&
        ($(this)[0].selectionStart >= text.length - 2)) {
      event.preventDefault();
    }


    if(!isNaN($(this).val())) { 
      var dec = $(this).val();
      if(dec >= minset && dec <=  parseInt(SP_maxPr) ){ 

        var isfloat = $(this).val().indexOf('.');
        if(isfloat > 0){
          var decimal = $(this).val().split('.');  
          if(decimal[1].length > 2){ 
            dec = Dec2(parseFloat($(this).val()));        
          } else { 
            dec = $(this).val();       
          }
        } 
        priceSlider.noUiSlider.set(dec ); 
        $("#price-value").val(dec);
        isinputchange = true;
      } 

    } else {
      priceSlider.noUiSlider.set(0 );
      $("#price-value").val(0);
    }
  });
  
  $('#price-value').donetyping2(function(callback){
      var dec =  parseFloat($(this).val());
      if( (dec <  parseInt(SP_maxPr)) && (dec > minset) ){  console.log('call');
         filterProduct(dec,parseInt(SP_numofpro),SP_bugprice,proTagsStr,parseInt(SP_getdays),1,parseFloat(SP_custprice));   
         jq.cookie("SP_totbudget",dec, {expires: 365, path: '/'}); 
         SP_bugtotal = dec;
      }  
  });
  

  $("#price-value").on("blur", function (event) {
     var dec = $(this).val();
    if(dec >  parseInt(SP_maxPr) ){ 
      $("#price-value").val(parseInt(SP_maxPr));
      priceSlider.noUiSlider.set(parseInt(SP_maxPr));         
	  filterProduct(parseInt(SP_maxPr),parseInt(SP_numofpro),SP_bugprice,proTagsStr,parseInt(SP_getdays),1,parseFloat(SP_custprice));   
      jq.cookie("SP_totbudget",parseInt(SP_maxPr), {expires: 365, path: '/'}); 
      SP_bugtotal = parseInt(SP_maxPr);
    } else if(dec < minset ){
      $("#price-value").val(minset);
      priceSlider.noUiSlider.set(minset);       
	  filterProduct(minset,parseInt(SP_numofpro),SP_bugprice,proTagsStr,parseInt(SP_getdays),1,parseFloat(SP_custprice));   
      jq.cookie("SP_totbudget",minset, {expires: 365, path: '/'}); 
      SP_bugtotal = minset;	
    }
    //isinputchange = true;
  });
  
  /*
  var qtyValue = document.getElementById('qty-value');
  qtySlider.noUiSlider.on('update', function (values, handle) {
    qtyValue.innerHTML = parseInt(values[handle]);  
  });*/

  deliverySlider = document.getElementById('deliverySlider');
  var pipsSlider = document.getElementById('slider-pips');
  noUiSlider.create(deliverySlider, {
    animationDuration: 300,
    start: [0],
    step: 1,
    range: {
      'min': 0,
      'max': 100
    },
    //   pips: {mode: 'count', values: 1},
    format: {
      to: function (value) {      
        return value;
      },
      from: function (value) {
        return value;
      }
    }
  });

  
   qtySlider = document.getElementById('qtySlider');
  noUiSlider.create(qtySlider, {
    animationDuration: 300,
    start: [0],
    step: 1,
    range: {
      'min': parseInt(SP_minqty),
      'max': parseInt(SP_maxqty)

    },
    format: {
      to: function ( value ) {
        return value;
      },
      from: function ( value ) {
        return value;
      }
    }
  });

  
  var qtyValue = document.getElementById('qty-value');
 /* qtySlider.noUiSlider.on('update', function (values, handle) {    
    if(isqtychange){      
    var qty =Math.round(values[handle]);       
    qtyValue.value = Math.round(values[handle]); 
    filterProduct(parseFloat(SP_bugtotal),qty,SP_bugprice,proTagsStr,parseInt(SP_getdays),1,parseFloat(SP_custprice)  );
    jq.cookie("SP_numofpro", qty, {expires: 365, path: '/'});  
    SP_numofpro = qty;
    } 
  });
 */
  
 
  $("#qty-value").on("change keyup", function (event) {
  		isqtychange = true;     
    var q_val = Math.round($(this).val()); 
    if($(this).val() >= parseInt($(this).attr('min')) && $(this).val() <= parseInt($(this).attr('max')) ){   

     if(!isNaN($(this).val())) { 
       $("#qty-value").val( q_val);
       	qtySlider.noUiSlider.set( q_val);
    
     } else {
     	$("#qty-value").val(0);
       	qtySlider.noUiSlider.set(0);    
     }                                     
    } 
     
  });
 
  $('#qty-value').donetyping(function(callback){
     var q_val = Math.round($(this).val()); 
     if( (q_val < parseInt(SP_maxqty)) &&  (q_val > parseInt(SP_minqty)) ){     console.log('call');
       filterProduct(parseFloat(SP_bugtotal),q_val,SP_bugprice,proTagsStr,parseInt(SP_getdays),1,parseFloat(SP_custprice)  );
   	   jq.cookie("SP_numofpro", q_val, {expires: 365, path: '/'});  
   	   SP_numofpro = q_val;
      }  
  });
  
  $('#qty-value').donetyping2(function(callback){
     var q_val = Math.round($(this).val()); 
     if( (q_val < parseInt(SP_maxqty)) &&  (q_val > parseInt(SP_minqty)) ){     console.log('call');
       filterProduct(parseFloat(SP_bugtotal),q_val,SP_bugprice,proTagsStr,parseInt(SP_getdays),1,parseFloat(SP_custprice)  );
   	   jq.cookie("SP_numofpro", q_val, {expires: 365, path: '/'});  
   	   SP_numofpro = q_val;
      }  
  });
  
 $("#qty-value").on("blur", function (event) {
   var q_val = Math.round($(this).val());    
   if(q_val > parseInt(SP_maxqty) ){    console.log('calls');
      $("#qty-value").val(parseInt(SP_maxqty));
      qtySlider.noUiSlider.set(parseInt(SP_maxqty));         
	  filterProduct(parseFloat(SP_bugtotal),parseInt(SP_maxqty),SP_bugprice,proTagsStr,parseInt(SP_getdays),1,parseFloat(SP_custprice)  );
   	  jq.cookie("SP_numofpro", parseInt(SP_maxqty), {expires: 365, path: '/'});  
   	  SP_numofpro = parseInt(SP_maxqty);
    } else if(q_val < parseInt(SP_minqty) ){   console.log('calld');
      $("#qty-value").val(parseInt(SP_minqty));
      qtySlider.noUiSlider.set(parseInt(SP_minqty));         
	  filterProduct(parseFloat(SP_bugtotal),parseInt(SP_minqty),SP_bugprice,proTagsStr,parseInt(SP_getdays),1,parseFloat(SP_custprice)  );
   	  jq.cookie("SP_numofpro", parseInt(SP_minqty), {expires: 365, path: '/'});  
   	  SP_numofpro = parseInt(SP_minqty);
    }
 });
  
  
  var deliveryValue = document.getElementById('delivery-value');
   /* deliverySlider.noUiSlider.on('update', function (values, handle) {    
    deliveryValue.innerHTML = parseInt(values[handle]); 
  });  */
  
    deliverySlider.noUiSlider.on('update', function (values, handle) {    
    
    deliveryValue.value = Math.round(values[handle]); 
    if(isdaychange){
    var day_value = Math.round(values[handle]); 
    filterProduct(parseFloat(SP_bugtotal),parseInt(SP_numofpro),SP_bugprice,proTagsStr,day_value,1,parseFloat(SP_custprice));   

    var currentDate = new Date();          
    currentDate.setDate(currentDate.getDate() + day_value);    
    var monthdate = currentDate.getMonth()+1;  
    var final_days1 = monthdate +'/'+ currentDate.getDate() +'/'+currentDate.getFullYear();  
  //  $(".filter-block").find(".deli_value").text(day_value); 
       $(".filter-block").find("#delivery-value").val(day_value); 
    jq.cookie("SP_datevalue", final_days1, {expires: 365, path: '/'});
    SP_datevalue = final_days1; 
    SP_getdays = day_value;
    }
  });  
   $("#delivery-value").keypress(function (evt) {
 //   evt.preventDefault();
  });
   $("#delivery-value").on(" change blur keyup", function (event) {
      deliverySlider.noUiSlider.set( Math.round(this.value));
      isdaychange = true;
   });
  
  $('#Sortiwg').change(function(){
   var sort = $(this).val();
    window.location.href = window.location.pathname+'?sort_by='+sort;
  });
  
  if(SP_bugtotal == null || SP_bugtotal == undefined){
    SP_bugtotal = SP_maxPr;
  }
  if(SP_bugprice == 'total_budget'){
    $('.pricetype').text('Order Budget');	
    $('.price_min').text(SP_minprice)
  }
  
  if(SP_numofpro == null || SP_numofpro == undefined){
    SP_numofpro = SP_maxqty;
  }
  /* collection page - assign value range slider */
  setTimeout(function(){    
    var price_value = $(".range-values #price-value");   
    var SP_bugtotal_per =  100*SP_bugtotal/SP_maxPr;        
    var SP_numofpro_per =  100*SP_numofpro/SP_maxqty;

    if(SP_bugtotal != null && SP_bugtotal != undefined){       
      price_value.val(parseFloat(SP_bugtotal));      
      $(".filter-block").find(".sel_value").text(SP_maxPr);
      $('#priceSlider').find(".noUi-origin").css('left', parseInt(SP_bugtotal_per)+"%");
    }
    var range_value = $(".range-values").find("#qty-value"); 
    if(SP_numofpro != null && SP_numofpro != undefined){      
      range_value.val(parseInt(SP_numofpro));
      $(".filter-block").find(".Qty_value").text(SP_maxqty);
      $('#qtySlider').find(".noUi-origin").css('left', parseInt(SP_numofpro_per)+"%");
    }else{      
      range_value.text('0');
    }
    
     
    
  }, 2000); 
  GetSelected();showDays();
}

function showDays(){  
  /* Get days on cookie date */
  
  var SP_datevalue = $.cookie("SP_datevalue");
  var currentDate = new Date();
  var monthdate = currentDate.getMonth()+1;
  var current_date = monthdate +'/'+ currentDate.getDate() +'/'+currentDate.getFullYear(); 
  var start = $('#datepicker').val();     
  var startDay = new Date(current_date);
  var endDay = new Date(SP_datevalue); 
  var millisecondsPerDay = 1000 * 60 * 60 * 24; 
  var millisBetween = endDay.getTime() - startDay.getTime(); 
  var days = millisBetween / millisecondsPerDay;
  var final_days = Math.floor(days);
  if(isNaN(final_days)) { final_days = SP_maxdays; }

  if(SP_datevalue != null && SP_datevalue != undefined){
    $(".range-values #delivery-value").val(final_days);
    $.cookie("SP_days", final_days, {expires: 365, path: '/'});
    SP_getdays = final_days;

  }else{
    $(".range-values #delivery-value").val(SP_maxdays);
    $.cookie("SP_days", SP_maxdays, {expires: 365, path: '/'});
    SP_getdays = SP_maxdays;
  }
setTimeout(function(){
  var ddate_per =  (100*final_days)/SP_maxdays; 
  $('#deliverySlider').find(".noUi-origin").css('left', parseInt(ddate_per)+"%");
  if(SP_datevalue != null && SP_datevalue != undefined){
    $(".filter-block").find(".delivery-value").val(SP_maxdays);
  } 
 
},2000);
}

function GetSelected() {   
  /* Collection Page - Change tags */
  if(proTagsStr != null && proTagsStr!= undefined) {
    var get_str = $.cookie("SP_protag");  
    var custPrice = parseFloat($.cookie("SP_custprice")); 
    var proTags = get_str.split(","); 
  }else{
    var proTags = [];  
    var custPrice = 0;
    $("input:checked").each(function () {        
      proTags.push($(this).val());   
     // custPrice = custPrice + parseFloat($(this).attr('price'));
    });     
  } 
  //console.log(SP_selcolor);
  //$('.filter-tag').find('.input-chckbx').not('[clr="'+SP_selcolor+'"]').remove(); 
  /* tags */
  var jq = $;
  $('.check_pro').off('click').on('click',function(){ 
    var curr_arr = [];
    if($(this).prop("checked") == true){     
      proTags.push($(this).val()); 
     // custPrice = custPrice + parseFloat($(this).attr('price'));
    }
    else{   
      proTags.splice( proTags.indexOf($(this).val()),1 ); 
      //custPrice = custPrice - parseFloat($(this).attr('price'));
    }
    custPrice = 0;
   $.each($("input[name='chckbox']:checked"), function(){  
      curr_arr.push(parseFloat($(this).attr('price')));    
    });  
    if(curr_arr.length > 0){
    custPrice = Math.min.apply(Math,curr_arr);
    }
    proTagsStr = proTags.toString(); console.log(proTagsStr,'proTagsStr');
    SP_custprice = parseFloat(custPrice)
    filterProduct(parseFloat(SP_bugtotal),parseInt(SP_numofpro),SP_bugprice,proTagsStr,parseInt(SP_getdays),1,parseFloat(custPrice));
    jq.cookie("SP_protag", proTags.toString(), {expires: 365, path: '/'});  
    jq.cookie("SP_custprice", custPrice, {expires: 365, path: '/'});
    
  });
    var jq = $;
  
  /* Collection Page - Change Price and budget */
  $('#priceSlider')[0].noUiSlider.on('change',function(value){  isinputchange = true;  console.log('calld');
    var val = JSON.parse(value);  
    $('#price-value').val(Math.round(val));      
    filterProduct(Math.round(val),parseInt(SP_numofpro),SP_bugprice,proTagsStr,parseInt(SP_getdays),1,parseInt(SP_custprice));   
    jq.cookie("SP_totbudget",Math.round(val), {expires: 365, path: '/'}); 
    SP_bugtotal = val;
  });

  /* Collection Page - Change Quantity */
  $('#qtySlider')[0].noUiSlider.on('change',function(value){   isqtychange = true;
    var qty = JSON.parse(value);  
   $('#qty-value').val(Math.round(qty));
    filterProduct(parseInt(SP_bugtotal),qty,SP_bugprice,proTagsStr,parseInt(SP_getdays),1,parseInt(SP_custprice)  );
    jq.cookie("SP_numofpro", qty, {expires: 365, path: '/'});  
    SP_numofpro = qty;

  });

  /* Collection Page - Change Day wise date*/
  $('#deliverySlider')[0].noUiSlider.on('change',function(value){   isdaychange = true;
    var day_value = JSON.parse(value); 
    filterProduct(parseInt(SP_bugtotal),parseInt(SP_numofpro),SP_bugprice,proTagsStr,day_value,1,parseInt(SP_custprice));   

    var currentDate = new Date();          
    currentDate.setDate(currentDate.getDate() + day_value);    
    var monthdate = currentDate.getMonth()+1;  
    var final_days1 = monthdate +'/'+ currentDate.getDate() +'/'+currentDate.getFullYear();  
    $(".filter-block").find("#delivery-value").val(day_value);   
    jq.cookie("SP_datevalue", final_days1, {expires: 365, path: '/'});
    SP_datevalue = final_days1; 
    SP_getdays = day_value;
  });
}

function jumpTostep(obj){
  
  /* Redirect to next step */
  if($("#step-1").is(":visible")){    
    var price_pro = $(obj).parents('#step-1');
    var buget_price_input = $("input[name='pck-selector']:checked").parents('.input-i-bx').find('.sp-pricebox');
    var per_price_data = $("input[name='pck-selector']:checked").attr("data_number");  
    var buget_price_val = buget_price_input.val();
    var err_add = buget_price_input;       
    var per_pro_data = $(".sp-totpro").attr("data_number"); 
    var per_pro_min = $(".sp-totpro").attr("minprice"); 
    var num_products = $(".sp-totpro").val();   
    var file_blank = "This field Can't be blank";
    var minprice = buget_price_input.attr('minprice');
    var bugprice = price_pro.find("input[name='pck-selector']:checked").attr('data-value'); 
    var currency = $('[name="SP_curr"]').val(); 

    if (!$("input[name='pck-selector']").is(':checked') ){
      price_pro.find('.stp-error').text("Please select price budget");  
      $("input[name='pck-selector']").addClass("input-has-error");
      return false;
    }
    else if(buget_price_val == '' ){
      price_pro.find('.stp-error').text(file_blank);
      price_pro.find(".sp-pricebox").focus();
      err_add.parent('.price-i-bx').addClass("input-has-error");
      return false;
    }
    else if( buget_price_val == 0 ){
      price_pro.find('.stp-error').text("Please enter more than 0 value");
      price_pro.find(".sp-pricebox").focus();
      err_add.parent('.price-i-bx').addClass("input-has-error");
      return false;
    }

    else if(isNaN(buget_price_val)){
      price_pro.find('.stp-error').text("Please enter valid value");
      price_pro.find(".sp-pricebox").focus();
      err_add.parent('.price-i-bx').addClass("input-has-error");
      return false;
    }    
    else if(parseFloat(buget_price_val) > per_price_data){     
      price_pro.find('.stp-error').text("You should add less or equal than " + per_price_data);
      return false;
    }
    else if(parseFloat(buget_price_val) < minprice){ 
      if(bugprice == 'per_product_budget') { 
        price_pro.find('.stp-error').text("Sorry but we need at least " +currency +minprice+' per product');
      } else {
        price_pro.find('.stp-error').text("Sorry but we need at least a total budget of " +currency +minprice);
      }

      return false;
    }
     else if( ! Number.isInteger(parseFloat(num_products))){
      price_pro.find('.stp-error').text("Please enter valid quantity");
      price_pro.find(".sp-totpro").focus();
      price_pro.find(".sp-totpro").parent('.price-i-bx').addClass("input-has-error");
      return false;
    }
    else if(num_products == '' ){
      price_pro.find('.stp-error').text(file_blank);
      price_pro.find(".sp-totpro").focus();  
      price_pro.find(".sp-totpro").parent('.price-i-bx').addClass("input-has-error");
      return false;
    }
    else if( num_products == 0 ){
      price_pro.find('.stp-error').text("Please enter more than 0 value");
      price_pro.find(".sp-totpro").focus();
      price_pro.find(".sp-totpro").parent('.price-i-bx').addClass("input-has-error");
      return false;
    } 
    else if(parseInt(num_products) > per_pro_data){
      price_pro.find('.stp-error').text("Sorry we can’t fulfill more than "+per_pro_data+" products per order!" );
      price_pro.find(".sp-totpro").focus();
      price_pro.find(".sp-totpro").parent('.price-i-bx').addClass("input-has-error");
      return false;
    }
    else if( parseInt(num_products) < parseInt(per_pro_min) ){
      price_pro.find('.stp-error').text("Sorry our minimum order is at least "+per_pro_min+" pieces per order");
      price_pro.find(".sp-totpro").focus();
      price_pro.find(".sp-totpro").parent('.price-i-bx').addClass("input-has-error");

      return false;
    }
    else{
      price_pro.find('.stp-error').text(" ");
      price_pro.find("input[name='pck-selector']:checked").val(buget_price_val);

      $(".sp-totpro").parent('.price-i-bx').removeClass("input-has-error");
      $(".sp-pricebox").parent('.price-i-bx').removeClass("input-has-error");
      $.cookie("SP_bugprice", bugprice, {expires: 365, path: '/'});
      $.cookie("SP_totbudget",buget_price_val, {expires: 365, path: '/'});
      $.cookie("SP_numofpro", num_products, {expires: 365, path: '/'});
      SP_bugtotal = bugprice;
      SP_totbudget = buget_price_val;
      SP_numofpro = num_products;
    };
  };
  if($("#step-2").is(":visible")){
    var arr = [];
    var pro_tag = $(obj).parents('#step-2'); 
    var cust_price = 0;
     $.each($("input[name='chckbox']:checked"), function(){  
      arr.push($(this).val());   
      cust_price = cust_price + parseFloat($(this).attr('price')); 
    });  

    $.cookie("SP_protag", arr.toString(), {expires: 365, path: '/'}); 
    $.cookie("SP_custprice", cust_price, {expires: 365, path: '/'}); 
    $.cookie("SP_selcolor", $("input[name='cust_options']:checked").val(), {expires: 365, path: '/'});

    proTagsStr = arr.toString();
    SP_custprice= cust_price ;
  }; 
  $("#datepicker").on("change",function (){     
    $.cookie("SP_datevalue", $(this).val(), {expires: 365, path: '/'});
    SP_datevalue = $(this).val();
  }); 
  $('#' + $(obj).attr('step-id')).removeClass('d-none').siblings('.page-steps').addClass('d-none'); 
  if($(obj).hasClass('sp_finished')){
    location.href = '/collections/iwg-products';
  }
}

function removeCartProduct(){
    
    var crtError = $.cookie("SP_carterror"); 
  
   if(crtError != '' && crtError != undefined){ 
  	 	$('.SP_iwg').addClass('SP_errMsg').html(crtError);
   } 
 
  
 /*$(window).load(function(){
  	var remCode = $.cookie("SP_code");   
    console.log(remCode,'remCode');   
    if(remCode != '' && remCode != undefined){
      $('.SP_loading').addClass('SP_show');
      removeItem($('[code="'+remCode+'"]:visible').find('.remove__tiredpro')); 		   
   }
 });*/
  
   $.cookie('SP_carterror', ''); 
  setTimeout(function(){     
    $('.SP_iwg').text('').removeClass('SP_errMsg'); 
  },10000);
  
  $(document).on('click', '.remove__tiredpro', function(){
    removeItem($(this));
  });
  
  function removeItem(obj){
  //  $.cookie("SP_code",'');  
    var curr_btn = obj;
    var curr_item_box = curr_btn.parents('tr');
    var curr_line_index = curr_item_box.attr("line");  
    var curr_customify_id = curr_item_box.attr("customify_id");
    var curr_line_code = curr_item_box.attr("code"); 
    var curr_mq = curr_item_box.attr("moq");   
  //  var cart_qty = curr_item_box.attr("sp_qty"); 
    var curr_id = curr_item_box.attr("vid"); 
    var curr_pro_id = curr_item_box.attr("prodid"); 
    var tot_rem_item = $('[code="'+curr_line_code+'"]').length;   
 
    Shopify.queue = [];
	
   for(k=0; k < tot_rem_item; k++){
      Shopify.queue.push({line_index: curr_line_index});
      if(curr_customify_id != ''){
         curr_line_index++;
      } else {
        curr_line_index--;	
      }
     
    }
   
    
   if(curr_customify_id != ''){
      Shopify.queue.reverse();
    }
    
    Shopify.queue1 = [];
   /* 
    $('[prodid="'+curr_pro_id+'"]').not(curr_btn.parents('tr')).each(function(){ 
      var cart_qty =$(this).attr('sp_qty'); 
      var property =$(this).attr('code');
      var line_index = $(this).attr("line"); 
      var customify_id = $(this).attr("customify_id"); 
      
      if( parseInt(cart_qty) <  parseInt(curr_mq)){ 
        var ptitle = $(this).attr('pTitle');
        var purl = $(this).attr('pURL');
        var rem_item = $('[code="'+property+'"]').length;  
        for(k=0; k < rem_item; k++){
          Shopify.queue1.push({line_index: line_index});
           if(customify_id != ''){
            line_index++;
           } else {
           	line_index--;
           }
         }
        if(customify_id != ''){ 
          Shopify.queue1.reverse();
        }
       $.cookie("SP_carterror", 'Sorry, your order for <b>'+ptitle+'</b> does not meet our minimum quantity and is removed from your shopping cart. Click <a href="'+purl+'"> <b>here</b> </a>  to order again!', {expires: 365, path: '/'});            
      }   
    });
    */
  
    //Shopify.queue = $.merge( $.merge( [], Shopify.queue ), Shopify.queue1 );
   
    Shopify.moveAlong = function() { 
      if (Shopify.queue.length ) {
        var request = Shopify.queue.shift();
        var qty_temp = parseInt(request.p_qty);
        var data = 'line='+ request.line_index + '&quantity=0'; 
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          dataType: 'json',
          data: data,            
          success: function(res){  
            Shopify.moveAlong();              
          },
          error: function(){              
            if (Shopify.queue.length){
              Shopify.moveAlong()
            } else {
              window.location.href = '/cart';  
            }
          }
        });
      } else {
        window.location.href = '/cart';  
      }
    };
    Shopify.moveAlong();
  }
}


});

/*
setTimeout(function(){
if (typeof jQuery == 'undefined'){
  
  var script = document.createElement('script');
  script.src = 'https://code.jquery.com/jquery-3.4.1.min.js';
  script.type = 'text/javascript';
  script.onload = start;
  document.getElementsByTagName('head')[0].appendChild(script);
}
else{
  $(document).ready(function() {   
    start();
  });
}
},1000);
*/